// TODO: put me in some "auth manager" / constants file later
import { authToken, isLoggedIn } from "../stores.js";
import { refreshAuthToken } from "../api/client.js";
import { get } from "svelte/store";
import { authTokenLocalStorage } from "./storage.js";

// processNewCredentials processes a credentialsResponse and stores the data in localstorage and the App token store.
export const processNewCredentials = (credentialsResponse) => {
    authToken.set(credentialsResponse);
    authTokenLocalStorage.setJSON(credentialsResponse);
    isLoggedIn.set(true);
};

// attemptAuthTokenRefresh attempts to refresh the auth token, updating isLoggedIn state if so
export const attemptAuthTokenRefresh = async () =>
    new Promise(async (resolve, _) => {
        console.log("Attempting auth token refresh");

        // We will only attempt a refresh if we have a token in localstorage. If we don't, the attempt will always fail.
        const maybeRefreshToken = get(authToken).refresh_token;
        console.log("mrt", maybeRefreshToken);
        if (typeof maybeRefreshToken !== "string" || maybeRefreshToken.length === 0) {
            console.log("fail");
            resolve(false);
            return;
        }
        console.log("Attempting auth token refresh");
        return await refreshAuthToken({
            statusHandlers: {
                "200": ({ data }) => {
                    processNewCredentials(data);
                    resolve(true);
                }
            },
            onError: function (err) {
                console.log("refresh auth token error:", err);
                resolve(false);
                // client must reauth.
                authToken.set("");
                authTokenLocalStorage.remove();
                isLoggedIn.set(false);
            },
        });
    });
